import Sidebar from "@/components/Sidebar/SidebarView.vue";
import ProductPromoCode from "@/components/PromoCode/product_promo_code.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import Navbar from '@/components/Navbar/NavbarView.vue';

export default {
  name: "PromoCodesView",
  components: {
    Navbar,
    Sidebar,
    ProductPromoCode,
  },
  data() {
    return ({
      token_exists: null,
      user_details: { user_role: "" },
      is_loading_businesses: false,
      is_loading_products: false,
      businesses: [],
      profile_products: [],
      catalogue_products: [],
      selected_business_id: "",
      business_query: "",
      product_query: "",
    });
  },
  computed: {
    is_admin() {
      return this.token_exists && this.user_details?.user_role === "admin";
    },
    selected_business() {
      return (this.businesses || []).find(
        (business) => String(this.get_business_base_profile_id(business)) === String(this.selected_business_id),
      ) || null;
    },
    filtered_businesses() {
      const query = String(this.business_query || "").trim().toLowerCase();
      if (!query) return this.businesses;
      return (this.businesses || []).filter((business) => {
        const name = String(business?.company_name || "").toLowerCase();
        const owner = `${business?.base_profile?.creater?.first_name || ""} ${business?.base_profile?.creater?.last_name || ""}`.toLowerCase();
        return name.includes(query) || owner.includes(query);
      });
    },
    filtered_products() {
      const query = String(this.product_query || "").trim().toLowerCase();
      return (this.catalogue_products || []).filter((product) => {
        const product_name = String(product?.name || "").toLowerCase();
        return !query || product_name.includes(query);
      });
    },
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details() || { user_role: "" };

    if (this.is_admin) {
      this.fetch_businesses();
    }
  },
  methods: {
    get_token() {
      return get_token();
    },
    get_business_base_profile_id(business) {
      return business?.base_profile?.id || business?.base_profile_id || business?.id || "";
    },
    get_business_owner_name(business) {
      const first_name = business?.base_profile?.creater?.first_name || "";
      const last_name = business?.base_profile?.creater?.last_name || "";
      return `${first_name} ${last_name}`.trim() || "Unknown owner";
    },
    fetch_businesses() {
      this.is_loading_businesses = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
        method: "GET",
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.businesses = response.data || [];
        },
        error: (response) => {
          this.show_error(response, "An error occurred while loading businesses.");
        },
        complete: () => {
          this.is_loading_businesses = false;
        },
      });
    },
    select_business(business) {
      const base_profile_id = this.get_business_base_profile_id(business);
      if (!base_profile_id) return;

      this.selected_business_id = String(base_profile_id);
      this.product_query = "";
      this.profile_products = [];
      this.catalogue_products = [];
      this.fetch_profile_products();
    },
    fetch_profile_products() {
      if (!this.selected_business_id) return;

      this.is_loading_products = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profile_products/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          base_profile: this.selected_business_id,
          user_id: this.user_details?.user_id,
        }),
        success: (response) => {
          if (response.status !== "success") return;
          this.profile_products = response.data || [];
          this.catalogue_products = this.profile_products.filter(
            (product) => product?.id && String(product?.product_type?.name || "").toLowerCase() !== "service",
          );
        },
        error: (response) => {
          this.show_error(response, "An error occurred while loading company products.");
        },
        complete: () => {
          this.is_loading_products = false;
        },
      });
    },
    open_product_promo_code_manager(product) {
      if (!product?.id || !this.selected_business_id) return;

      this.$nextTick(() => {
        this.$refs.productPromoCodeRef?.open_product_promo_code_manager_modal?.({
          product,
          base_profile_id: this.selected_business_id,
        });
      });
    },
    open_catalogue_promo_code_manager() {
      if (!this.catalogue_products.length || !this.selected_business_id) return;

      this.$nextTick(() => {
        this.$refs.productPromoCodeRef?.open_catalogue_promo_code_manager_modal?.({
          products: this.catalogue_products,
          base_profile_id: this.selected_business_id,
        });
      });
    },
    view_product_details(product) {
      view_profile_product(this.$router, product);
    },
    view_business_profile(business) {
      const base_profile_id = this.get_business_base_profile_id(business);
      const type = business?.base_profile?.profile_type || "business";
      if (!base_profile_id) return;
      this.$router.push({ path: "/profile", query: { base: base_profile_id, type } });
    },
    handle_promo_update() {
      if (this.selected_business_id) {
        this.fetch_profile_products();
      }
    },
    show_error(response, fallback) {
      const response_data = response?.responseJSON || {};
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response_data.message || fallback,
        showConfirmButton: false,
        timer: 3000,
      });
    },
  },
};
